import * as React from "react";
import { SxProps } from "@mui/material";
import CollectionCard, { CollectionCardProps } from "../../Cards/CollectionCard";

import Slider, { Slide } from "../../Slider";

export type CollectionSliderProps = {
    sx?: SxProps;
    list: (CollectionCardProps & { id: number })[];
    background?: "default" | "paper";
    paginate?: boolean;
};

const CollectionSlider: React.FC<CollectionSliderProps> = (props) => {
    const { list, paginate = true, background = "default", sx = {} } = props;

    return (
        <Slider
            paginate={paginate}
            background={background}
            slidesPerGroup={4}
            spaceBetween={16}
            sx={{
                ...sx,
                ".swiper-slide": {
                    flexShrink: 1,
                    height: "auto",
                },
            }}
        >
            {list.map((Collection) => (
                <Slide key={Collection.id}>
                    <CollectionCard {...Collection} />
                </Slide>
            ))}
        </Slider>
    );
};

export default CollectionSlider;
